/* @flow */

import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMembershipEmailAddress } from '@e180/domain/lib/membership/util';
import { getUserFullName } from '@e180/domain/lib/user/util';

import { getAuthenticationToken } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import { liveChatScriptURL } from 'plugin/live-chat/setting/liveChatSettings';
import { getLiveChatPropertyId } from 'plugin/live-chat/util/liveChatUtils';
import useEvent from 'src/shared/domain/event/hook/useEvent';
import useMembership from 'src/shared/domain/membership/hook/useMembership';
import useSelf from 'src/shared/domain/user/hook/useSelf';
import useLiveChat from 'plugin/live-chat/hook/useLiveChat';
import { updateStatus } from 'plugin/live-chat/action/liveChatAction';

export function showLiveChatWidget({
  selfUser,
  membership,
  propertyId,
  onStatusChange,
}) {
  window.Tawk_LoadStart = new Date();
  window.Tawk_API = {
    visitor: {
      name: selfUser ? getUserFullName(selfUser) : null,
      email: membership ? getMembershipEmailAddress(membership) : null,
    },
    onStatusChange: (status) => {
      onStatusChange(status);
    },
  };

  window.loadJS(liveChatScriptURL.replace('{property_id}', String(propertyId)));
}

export function hideLiveChatWidget() {
  window.Tawk_API.endChat();
  window.Tawk_API.hideWidget();
}

export default function useLiveChatVisitorAuth() {
  const token = useSelector(getAuthenticationToken);
  const hasLiveChat = useLiveChat() && token;
  const event = useEvent();
  const membership = useMembership();
  const selfUser = useSelf();
  const propertyId = getLiveChatPropertyId(event);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (hasLiveChat) {
      showLiveChatWidget({
        selfUser,
        membership,
        propertyId,
        onStatusChange: (newStatus) => {
          dispatch(updateStatus(newStatus));
        },
      });
    } else if (window.Tawk_API) {
      hideLiveChatWidget();
    }
  }, [token]);
}
